//#region src/core/search/noop-search-adapter.ts
var NoOpSearchAdapter = class {
	async init() {}
	async getLastIndexedAt() {}
	async isFullReindexPending() {
		return false;
	}
	async indexData() {}
	async search() {
		return [];
	}
	async add() {}
	async remove() {}
	async syncChanges(_options) {}
	async clear() {}
	async abortIndexing() {}
};
//#endregion
export { NoOpSearchAdapter as t };

//# sourceMappingURL=noop-search-adapter-Cwic19bX.js.map